export default {"src":"/_next/static/media/0x75af292c1c9a37b3ea2e6041168b4e48875b9ed5.54d15be3.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};